export default "__VITE_ASSET__BLUCAjEO__"